import { IntakeFormTemplate } from '../types/formBuilder';
import { RIGHTS_FIELDS } from '../components/RightsIntakeForm';

// ===== RIGHTS FORM =====
export const DEFAULT_RIGHTS_FORM: Omit<IntakeFormTemplate, 'id' | 'createdAt' | 'updatedAt'> = {
  name: 'Rights Intake Form',
  nameHe: 'טופס זכויות',
  nameEn: 'Rights Intake Form',
  description: 'Form to assess client rights and eligibility for various benefits and services',
  type: 'rights',
  fields: RIGHTS_FIELDS.map((field, index) => ({
    id: `rights_${field.field_name}`,
    field_name: field.field_name,
    label: field.label,
    type: field.type as any,
    options: field.options || undefined,
    description: field.description || undefined,
    required: false,
    order: index
  })),
  isActive: true,
  isDefault: true,
  createdBy: 'system',
  version: 1,
  sharedWith: 'all',
  allowedRoles: []
};

// ===== EMOTIONAL FORM =====
const EMOTIONAL_QUESTIONS_DATA = [
  { field_name: 'anxiety_level', label: 'דרג/י את רמת החרדה הכללית (1–5)', type: 'scale', options: ['1', '2', '3', '4', '5'] },
  { field_name: 'has_trauma', label: 'האם חווית אירוע טראומטי?', type: 'yes_no' },
  { field_name: 'trauma_description', label: 'תאר/י את האירוע', type: 'textarea' },
  { field_name: 'coping_methods', label: 'אילו שיטות התמודדות עוזרות לך?', type: 'multiselect', options: ['ספורט', 'מדיטציה', 'שינה', 'כתיבה', 'שיחה עם חברים/משפחה', 'טיפול', 'אחר'] },
  { field_name: 'emotional_strengths', label: 'מהן החוזקות הרגשיות שלך?', type: 'multiselect', options: ['חוסן נפשי', 'אמפתיה', 'יצירתיות', 'אופטימיות', 'הומור', 'ויסות רגשי'] },
  { field_name: 'support_network', label: 'מי נמצא ברשת התמיכה שלך?', type: 'multiselect', options: ['משפחה', 'חברים', 'מטפל/ת', 'קהילה/מנהיג', 'ארגון', 'אחר'] },
  { field_name: 'life_satisfaction', label: 'עד כמה את/ה מרוצה מהחיים?', type: 'scale', options: ['1', '2', '3', '4', '5'] },
  { field_name: 'emotional_goal', label: 'מה יכול לעזור לך להתקדם רגשית?', type: 'multiselect', options: ['לימוד כישורי התמודדות', 'שיפור יחסים', 'שיחה על הנושא', 'הבנת הסיבה השורשית', 'שיפור חיי העבודה', 'שיפור גישה לזכויות'] },
  { field_name: 'reason', label: 'מה הסיבה לפנייה לתמיכה רגשית?', type: 'multiselect', options: ['חרדה', 'דיכאון', 'קושי בוויסות רגשי', 'משבר', 'טראומה', 'דימוי עצמי נמוך', 'ביקורת עצמית', 'בדידות', 'חוסר תמיכה', 'קשיים בזוגיות/יחסים', 'עייפות', 'שחיקה', 'מודעות עצמית נמוכה', 'אחר'] },
  { field_name: 'problem_definition', label: 'איך היית מגדיר/ה את הבעיה?', type: 'textarea' },
  { field_name: 'success_definition', label: 'איך תדעי/ה שהבעיה נפתרה?', type: 'textarea' },
  { field_name: 'problem_start_when', label: 'מתי התחילה הבעיה?', type: 'text' },
  { field_name: 'problem_frequency', label: 'מתי זה מופיע?', type: 'select', options: ['תמיד', 'רוב היום', 'חלק מהיום', 'לעיתים רחוקות', 'אף פעם'] },
  { field_name: 'problem_situations', label: 'באילו מצבים את/ה מרגיש/ה את הבעיה?', type: 'textarea' },
  { field_name: 'problem_reaction', label: 'מה את/ה עושה כשהבעיה עולה?', type: 'textarea' },
  { field_name: 'felt_better_when', label: 'האם היה תקופה שהרגשת טוב יותר ומתי?', type: 'textarea' },
  { field_name: 'contact_persons', label: 'אל מי אפשר לפנות לעזרה?', type: 'multiselect', options: ['משפחה', 'חברים', 'מטפלים', 'קהילה', 'אמונה', 'אחר'] },
  { field_name: 'birth_pregnancy_experiences', label: 'חוויות לידה והריון', type: 'yes_no' },
  { field_name: 'childhood_satisfaction', label: 'שביעות רצון מהילדות', type: 'select', options: ['1 – לא מרוצה', '2 – מרוצה במעט', '3 – מרוצה במידה בינונית'] },
  { field_name: 'depression_screen', label: 'האם לאחרונה חשת חוסר עניין או הנאה מפעילויות יומיומיות?', type: 'yes_no' },
  { field_name: 'anxiety_context', label: 'מתי את/ה מרגיש/ה חרדה בעוצמה הגבוהה ביותר?', type: 'multiselect', options: ['בבית', 'בעבודה', 'בסיטואציות חברתיות', 'בנהיגה', 'אחר'] },
  { field_name: 'anxiety_coping', label: 'איך את/ה מתמודד/ת כיום עם חרדה?', type: 'multiselect', options: ['תרופות', 'נשימות/הרפיה', 'שיחה', 'הימנעות', 'טיפול', 'אחר'] },
  { field_name: 'depression_days', label: 'כמה ימים בשבוע יש חוסר אנרגיה או חוסר עניין?', type: 'select', options: ['0', '1–2', '3–4', '5–7'] },
  { field_name: 'depression_difficulty', label: 'מה מקשה הכי הרבה להתחיל או לקום?', type: 'textarea' },
  { field_name: 'trauma_effect', label: 'האם האירוע הטראומטי עדיין משפיע על היום-יום?', type: 'yes_no' },
  { field_name: 'trauma_trigger', label: 'אילו מצבים מעוררים פלאשבקים או מצוקה?', type: 'textarea' },
  { field_name: 'regulation_context', label: 'מתי חווים את הקושי הגדול ביותר?', type: 'multiselect', options: ['עבודה', 'הורות', 'זוגיות', 'לבד', 'אחר'] },
  { field_name: 'self_criticism_thoughts', label: 'אילו מחשבות חוזרות במצבים האלה?', type: 'textarea' },
  { field_name: 'loneliness_contact', label: 'מי האדם הקרוב ביותר שאפשר לפנות אליו בשעת קושי?', type: 'text' },
  { field_name: 'loneliness_support_level', label: 'עד כמה את/ה מרגיש/ה שיש רשת תמיכה מספקת?', type: 'scale', options: ['1', '2', '3', '4', '5'] },
  { field_name: 'burnout_context', label: 'באיזה תחום את/ה חווה את השחיקה הגדולה ביותר?', type: 'multiselect', options: ['עבודה', 'הורות', 'טיפול בקרוב משפחה', 'לימודים', 'אחר'] },
  { field_name: 'burnout_recovery', label: 'מה עוזר לך להיטען מחדש (אם בכלל)?', type: 'multiselect', options: ['שינה', 'חופשה', 'פעילות גופנית', 'שיחה עם חברים', 'טיפול', 'אחר'] },
  { field_name: 'crisis_feeling', label: 'מהו הרגש המרכזי סביב המשבר?', type: 'multiselect', options: ['בלבול', 'ייאוש', 'פחד', 'אובדן שליטה', 'כעס', 'אחר'] },
  { field_name: 'help_needed', label: 'מה לדעתך יעזור לך בשלב זה?', type: 'multiselect', options: ['תמיכה רגשית', 'כלים מעשיים', 'גם וגם'] }
];

export const DEFAULT_EMOTIONAL_FORM: Omit<IntakeFormTemplate, 'id' | 'createdAt' | 'updatedAt'> = {
  name: 'Emotional Intake Form',
  nameHe: 'טופס רגשי',
  nameEn: 'Emotional Intake Form',
  description: 'Comprehensive emotional and mental health assessment',
  type: 'emotional',
  fields: EMOTIONAL_QUESTIONS_DATA.map((field, index) => ({
    id: `emotional_${field.field_name}`,
    field_name: field.field_name,
    label: field.label,
    type: field.type as any,
    options: field.options || undefined,
    required: false,
    order: index
  })),
  isActive: true,
  isDefault: true,
  createdBy: 'system',
  version: 1,
  sharedWith: 'all',
  allowedRoles: []
};

// ===== PROFESSIONAL/CAREER FORM =====
const PROFESSIONAL_QUESTIONS_DATA = [
  { field_name: 'employment_goal', label: 'מטרת תעסוקה עיקרית', type: 'select', options: ['עבודה ראשונה', 'הסבת קריירה', 'אחרי לידה', 'חזרה לעבודה', 'תמיכה אחרי פגיעה', 'הכשרה מקצועית מותאמת', 'שימור תעסוקה', 'ניהול שגרה תחת מגבלות'] },
  { field_name: 'secondary_goals', label: 'מטרות משניות (בחירה מרובה)', type: 'multiselect', options: ['הבהרת כיוון', 'הגדלת היקף משרה', 'שדרוג שכר', 'שינוי סביבת עבודה', 'גמישות תעסוקתית', 'ארגון משפחה/עבודה'] },
  { field_name: 'time_horizon', label: 'אופק זמן מועדף', type: 'select', options: ['חודשיים', '3–6 חודשים', '6–12 חודשים', 'מעל שנה'] },
  { field_name: 'strengths_top5', label: 'חוזקות אישיות מובילות (עד 5)', type: 'multiselect', options: ['חמלה','יצירתיות','סקרנות','למידה','התמדה','תושייה','הומור','תקווה','אהבה','יושרה','פרספקטיבה','הכרת הטוב','אומץ','משמעת עצמית','צדק','מנהיגות','נדיבות','ענווה'] },
  { field_name: 'strengths_contexts', label: 'הקשרים בהם החוזקות מיושמות', type: 'textarea' },
  { field_name: 'core_values', label: 'ערכים חשובים היום (עד 5)', type: 'multiselect', options: ['משמעות','חופש','איזון','למידה','ביטחון','ביטוי עצמי','שייכות','יציבות','השפעה','יצירתיות','שקט','צמיחה','משפחה','קהילה'] },
  { field_name: 'non_negotiables', label: 'דברים שאי אפשר להתפשר עליהם בעבודה', type: 'textarea' },
  { field_name: 'career_anchors', label: 'עוגני קריירה (עד 3)', type: 'multiselect', options: ['מומחיות','ניהול','אוטונומיה','ביטחון/יציבות','יזמות','משימה/שירות','אתגר','איזון עבודה-חיים'] },
  { field_name: 'anchor_examples', label: 'דוגמאות לעוגנים', type: 'textarea' },
  { field_name: 'riasec_types', label: 'תחומי עניין מקצועיים (בחר את כל הרלוונטיים)', type: 'multiselect', options: ['מעשי (R)','חוקר (I)','אמנותי (A)','חברתי (S)','יוזם (E)','קונבנציונלי (C)'] },
  { field_name: 'riasec_examples', label: 'דוגמאות לסביבות/משימות עבודה', type: 'textarea' },
  { field_name: 'energizers', label: 'מה נותן לך אנרגיה ביום-יום?', type: 'textarea' },
  { field_name: 'drainers', label: 'מה מרוקן לך את האנרגיה?', type: 'textarea' },
  { field_name: 'work_style', label: 'סגנון עבודה מועדף', type: 'multiselect', options: ['עצמאי/ת','עבודת צוות','היברידי','עם אנשים','עם נתונים','עבודה מעשית','אופן ספייס','משרד שקט'] },
  { field_name: 'schedule', label: 'שעות זמינות/היקף תעסוקה', type: 'multiselect', options: ['בוקר','צוהריים','ערב','משמרות','משרה חלקית','משרה מלאה','גמיש'] },
  { field_name: 'location_range', label: 'טווח גיאוגרפי ותחבורה', type: 'text' },
  { field_name: 'salary_expectation', label: 'ציפיות שכר (חודשי/שעתי)', type: 'text' },
  { field_name: 'accommodations', label: 'התאמות נדרשות (פיזיות/נפשיות)', type: 'textarea' },
  { field_name: 'situation_track', label: 'בחר מסלול/ים רלוונטיים', type: 'multiselect', options: ['עבודה ראשונה','הסבת קריירה','אחרי לידה','חזרה לעבודה','אחרי פגיעה','הכשרה מקצועית','שימור תעסוקה','שגרת עבודה תחת מגבלות'] },
  { field_name: 'field_interest', label: 'תחומי עניין/תעשיות', type: 'multiselect', options: ['חינוך/הכשרה','טיפול ורווחה','מינהל/שירות לקוחות','כספים/חשבונאות','שיווק/תוכן','עיצוב/מדיה','טכנולוגיה','לוגיסטיקה/תפעול','בריאות','מקצועות יד'] },
  { field_name: 'training_needs', label: 'ידע או הכשרה חסרים', type: 'textarea' },
  { field_name: 'confidence_level', label: 'ביטחון עצמי תעסוקתי (0-10)', type: 'scale', options: ['0','1','2','3','4','5','6','7','8','9','10'] },
  { field_name: 'avoidance_patterns', label: 'ממה אתה נמנע בחיפוש עבודה?', type: 'textarea' },
  { field_name: 'fear_statements', label: 'חששות או מחשבות מעכבות', type: 'textarea' },
  { field_name: 'weekly_capacity_hours', label: 'כמה שעות בשבוע אתה זמין לעבודה?', type: 'number' },
  { field_name: 'network_assets', label: 'קשרים מקצועיים וחברתיים', type: 'textarea' },
  { field_name: 'next_2_weeks_actions', label: 'פעולות קונקרטיות לשבועיים הקרובים', type: 'textarea' },
  { field_name: 'current_status', label: 'מצב תעסוקתי נוכחי', type: 'select', options: ['מחוסר עבודה','מחפש/ת עבודה','בהכשרה','משרה חלקית','משרה מלאה','עצמאי/ת'] },
  { field_name: 'income_level', label: 'רמת הכנסה נוכחית (חודשי)', type: 'number' }
];

export const DEFAULT_PROFESSIONAL_FORM: Omit<IntakeFormTemplate, 'id' | 'createdAt' | 'updatedAt'> = {
  name: 'Professional/Career Intake Form',
  nameHe: 'טופס תעסוקתי מקצועי',
  nameEn: 'Professional/Career Intake Form',
  description: 'Comprehensive career and employment assessment based on VIA, ACT, Holland, and Schein models',
  type: 'professional',
  fields: PROFESSIONAL_QUESTIONS_DATA.map((field, index) => ({
    id: `professional_${field.field_name}`,
    field_name: field.field_name,
    label: field.label,
    type: field.type as any,
    options: field.options || undefined,
    required: false,
    order: index
  })),
  isActive: true,
  isDefault: true,
  createdBy: 'system',
  version: 1,
  sharedWith: 'all',
  allowedRoles: []
};

// ===== QUESTION BANK =====
// All unique questions that can be reused
export interface QuestionBankItem {
  id: string;
  category: 'rights' | 'emotional' | 'professional' | 'general';
  field_name: string;
  label: string;
  labelHe: string;
  labelEn?: string;
  type: string;
  options?: string[];
  description?: string;
  tags?: string[];
}

export const QUESTION_BANK: QuestionBankItem[] = [
  // Rights Questions
  ...RIGHTS_FIELDS.map(field => ({
    id: `q_rights_${field.field_name}`,
    category: 'rights' as const,
    field_name: field.field_name,
    label: field.label,
    labelHe: field.label,
    labelEn: field.field_name.replace(/_/g, ' '),
    type: field.type,
    options: field.options,
    description: field.description,
    tags: ['rights', 'benefits', 'eligibility']
  })),
  
  // Emotional Questions
  ...EMOTIONAL_QUESTIONS_DATA.map(field => ({
    id: `q_emotional_${field.field_name}`,
    category: 'emotional' as const,
    field_name: field.field_name,
    label: field.label,
    labelHe: field.label,
    type: field.type,
    options: field.options,
    tags: ['emotional', 'mental_health', 'wellbeing']
  })),
  
  // Professional Questions
  ...PROFESSIONAL_QUESTIONS_DATA.map(field => ({
    id: `q_professional_${field.field_name}`,
    category: 'professional' as const,
    field_name: field.field_name,
    label: field.label,
    labelHe: field.label,
    type: field.type,
    options: field.options,
    tags: ['career', 'employment', 'professional']
  }))
];

// Function to get questions by category
export function getQuestionsByCategory(category: string): QuestionBankItem[] {
  return QUESTION_BANK.filter(q => q.category === category);
}

// Function to search questions
export function searchQuestions(searchTerm: string): QuestionBankItem[] {
  const lower = searchTerm.toLowerCase();
  return QUESTION_BANK.filter(q => 
    q.label.toLowerCase().includes(lower) ||
    q.field_name.toLowerCase().includes(lower) ||
    q.tags?.some(tag => tag.includes(lower))
  );
}

